import { type FC } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { useFragment, graphql } from 'react-relay';
import { type NftPdpExhibitionNoteVideo_note$key } from './__generated__/NftPdpExhibitionNoteVideo_note.graphql';

import styles from './NftPdpExhibitionNoteVideo.scss';

type Props = {
    note: NftPdpExhibitionNoteVideo_note$key;
};

export const NftPdpExhibitionNoteVideo: FC<Props> = ({ note: noteRef }) => {
    const note = useFragment(
        graphql`
            fragment NftPdpExhibitionNoteVideo_note on NftExhibitionNoteVideoEmbedContent {
                embedCode
                caption
            }
        `,
        noteRef
    );
    const { embedCode, caption } = note;
    const videoWrapper = (
        <figure className={styles.videoWrapper}>
            <div
                className={styles.iframeWrapper}
                dangerouslySetInnerHTML={{ __html: embedCode || '' }}
            />
            {caption && (
                <figcaption className={`${styles.caption} ${styles.videoCaption}`}>
                    {caption}
                </figcaption>
            )}
        </figure>
    );
    const markup = renderToStaticMarkup(videoWrapper);
    return <div className={styles.bodyText} dangerouslySetInnerHTML={{ __html: markup }} />;
};
